import { React, PT } from '@gasbuddy/react';
import JSONTree from 'react-json-tree';
import { Modal, Button, Icon } from 'semantic-ui-react';
import { CopyToClipboard } from 'react-copy-to-clipboard';

export class RawDeetsModal extends React.Component {
  state = {}

  open = () => {
    this.setState({ opened: true, copied: false });
  }

  render() {
    const { title, data } = this.props;
    const { opened, copied } = this.state;
    return (
      <Modal
        open={opened}
        closeIcon
        closeOnEscape
        onClose={() => this.setState({ opened: false })}
        trigger={<Button floated="right" size="mini" onClick={this.open}>View Raw</Button>}
      >
        <Modal.Header>
          {title || 'Raw Details'}
        </Modal.Header>
        <Modal.Content>
          <JSONTree data={data} shouldExpandNode={(k, d, l) => l <= 1} />
        </Modal.Content>
        <Modal.Actions>
          <CopyToClipboard
            text={JSON.stringify(data, null, 2)}
            onCopy={() => this.setState({ copied: true })}
            options={{ format: 'text/plain' }}
          >
            <Button toggle icon active={copied} labelPosition="left">
              <Icon name={copied ? 'clipboard check' : 'clipboard'} />
              {copied ? 'JSON copied to clipboard!' : 'Copy JSON'}
            </Button>
          </CopyToClipboard>

          <Button basic onClick={() => this.setState({ opened: false })}>
            OK
          </Button>
        </Modal.Actions>
      </Modal>
    );
  }
}

RawDeetsModal.propTypes = {
  title: PT.string,
  data: PT.shape({}),
};

RawDeetsModal.defaultProps = {
  title: undefined,
  data: {},
};
